<script>
import { notify } from '@/helpers/notify' 
import {
  required
} from "vuelidate/lib/validators";
import Loader from "@/components/widgets/loader.vue";

export default {
  name: 'CreateStock',
  props:[
    "list",
    "data"
  ],
   components: { Loader },
  data() {
        return {
            groups:[
                { name:"Anten", code:"an",},
                { name:"Kablo", code:"ka"},
                { name:"Modem", code:"mo"},
                { name:"Sarf Malzeme", code:"sm"},
            ],
            groupList:[],
            userList:[],
            lines:[],
            form:{
                model:'',
                group:'',
                user_id:''
            },
            submitted: false,
            seri_no:'',
            adet:1,
            loading:false,
        };  
    },
    watch:{
        list(props){
            this.form = props
        }
    },
    created(){
        this.$http.post('/users?output=one&fields=id,name')
        .then(resp => { this.userList = resp.data })
    },
    validations: {
        form: {
            group: { required },
            model: { required },
            user_id: { required },
        },
    },
    methods: {
        close(){
            this.$parent.$bvModal.hide('modal-scoped')
        },
        newLine() {
            this.loading = false
            this.lines = { seri_no:this.seri_no, amount:this.adet }
            this.seri_no = ''
            const { model,user_id } = this.form

            this.$http.post('/stock/store', { ...this.lines,stock_group_id:model.id, user_id })
                .then(resp => {
                    if(!resp.data.error) this.form = {};

                    this.$emit('loadItems');
                    return notify.success(resp.data.message)
                })
        },
        getGroupList({target}){
            this.$http.post('/stock/product?id=' + target.value)
            .then(response => this.groupList = response.data )
        }
  },
};
</script>

<template>
  <b-modal 
        size="lg"
        id="modal-scoped"
        title="Depo Stok Ekleme"  
        no-close-on-backdrop 
        hide-footer>
      <form @submit.prevent="handleSubmit" @keydown.enter.prevent>
        <div class="row mb-2">
            <label class="col-sm-4 col-form-label" for="groups">Ürün Grubu</label>
            <div class="col-sm-8">
                <select 
                    class="form-control form-select"  
                    :class="{'is-invalid': submitted && $v.form.group.$error}" 
                    @change="getGroupList($event)"
                    v-model="form.group">
                    <option value="">Seçiniz</option>
                    <option :value="group.code" v-for="(group,i) in groups" :key="i">{{ group.name }}</option>
                </select>
                <div
                    v-if="submitted && !$v.form.group.required"
                    class="invalid-feedback"
                >
                Bu alanı doldurmak zorunludur.
                </div>
            </div>
        </div>
        <div class="row mb-2">
            <label class="col-sm-4 col-form-label" for="models">Tanım</label>
            <div class="col-sm-8">
                <select 
                    class="form-control form-select"  
                    :class="{'is-invalid': submitted && $v.form.model.$error}" 
                    v-model="form.model">
                    <option value="">Seçiniz</option>
                    <option :value="model" v-for="(model,i) in groupList" :key="i">{{ model.name }}</option>
                </select>
                <div
                    v-if="submitted && !$v.form.model.required"
                    class="invalid-feedback"
                >
                Bu alanı doldurmak zorunludur.
                </div>
            </div>
        </div>
        <div class="row">
            <label class="col-sm-4 col-form-label" for="depo">Depo</label>
            <div class="col-sm-8">
                <select 
                    class="form-control form-select"  
                    :class="{'is-invalid': submitted && $v.form.user_id.$error}" 
                    v-model="form.user_id">
                    <option value="">Seçiniz</option>
                    <option :value="user.id" v-for="(user,i) in userList" :key="i">{{ user.name }}</option>
                </select>
                <div
                    v-if="submitted && !$v.form.user_id.required"
                    class="invalid-feedback"
                >
                Bu alanı doldurmak zorunludur.
                </div>
            </div>
        </div>
        <hr>
        <Loader :loading="true" :load="loading">
            <div class="row mb-1" >
                <div class="col-md-12" style="max-height:480px;overflow:auto">
                    <div class="d-flex mb-1">
                        <div class="col-md-6 me-2">
                             <input
                                v-if="form.group == 'an' || form.group == 'mo'"
                                type="text"
                                class="form-control"
                                placeholder="Seri No" 
                                v-model="seri_no" 
                                @keyup.enter="newLine()"
                            />
                        </div>
                         <div class="col-md-4 me-2 ">
                            <div class="input-group mb-3">
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Adet" 
                                    v-model="adet" 
                                />
                                <span class="input-group-text">{{ form.model.unit }}</span>
                            </div>
                        </div>
                        <div class="col">
                            <button 
                            style="width:100%"
                            type="button"
                            class="btn btn-success" 
                            @click="newLine()">Ekle</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-2 mb-1" v-if="lines.seri_no || lines.amount" >
                <div class="col-md-12" style="max-height:480px;overflow:auto">
                Son Eklenen Data:
                    <div class="d-flex mb-1">
                        <div class="col-md-8 rounded-2 me-2 bg-light py-1 px-3">
                            {{ lines.seri_no }}
                        </div>
                         <div class="col-md-2 rounded-2 me-2 bg-light py-1 px-3">
                            {{ lines.amount }}
                        </div>
                        <div class="col d-grid gap-2">
                            <button class="btn btn-sm btn-block btn-danger">Sil</button>
                        </div>
                    </div>
                </div>
            </div>
        </Loader>
    </form>
</b-modal>
</template>  